module.exports = __webpack_public_path__ + "static/photo5-fde857b06cc508b4782a28f4e9f7f7ca.jpg";